import React from 'react';
import { pdf } from '@react-pdf/renderer';
import { GetScanResponse } from '../../api/scans';
import { GetMemberResponse } from '../../types/apiGeneratedTypes';
import { buildConsolidatedReportModel } from './consolidatedReportModel';
import { FbsReportData } from './fullBodyScanReportUtils';
import FullBodyScanConsolidatedPdf from './pdf/FullBodyScanConsolidatedPdf';

export interface ConsolidatedReportDownloadInput {
  scanData: GetScanResponse;
  reportData: FbsReportData;
  member?: GetMemberResponse | null;
  bookingId?: string;
  /** Same chip filters as the consolidated report tab. */
  selectedStatuses?: string[];
}

const sanitizeFilename = (value: string): string => {
  const cleaned = value.replace(/[/\\?%*:|"<>]/g, '-').trim();
  return cleaned || 'full-body-scan-report';
};

const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${filename}.pdf`;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

export async function triggerConsolidatedReportDownload({
  scanData,
  reportData,
  member,
  bookingId,
  selectedStatuses
}: ConsolidatedReportDownloadInput): Promise<void> {
  const model = buildConsolidatedReportModel({
    scanData,
    reportData,
    member,
    selectedStatuses
  });

  const filename = bookingId?.trim()
    ? sanitizeFilename(bookingId.trim())
    : 'full-body-scan-report';

  const blob = await pdf(<FullBodyScanConsolidatedPdf model={model} />).toBlob();

  downloadBlob(blob, filename);
}
